<template>
  <div id="app">
    <a-config-provider v-if="$store.getters.getUserLogin" :locale="zh_CN">
      <a-layout id="layout">
        <a-layout-header class="header" style="padding-left: 0;">
          <div class="logo">
            <img src="/static/logo_home_w.png" style="max-width: 100%;max-height: 100%;">
          </div>
          <a-menu theme="dark" style="background: none" mode="horizontal" :selected-keys="[choseMenuIndex]"
            :style="{ lineHeight: '64px' }">
            <a-menu-item :key="menuIndex" @click="choseMenu(menuIndex)" v-for="(menuItem, menuIndex) in menuList">
              {{ menuItem.name }}
            </a-menu-item>
          </a-menu>
          <div style="position:absolute;right: 25px;top: 0;color: #ffffff;display: flex">
            <ApplicationPanel :application-list="$store.getters.getAppList"></ApplicationPanel>
            <UserInfoPanel :user-info="getUser"></UserInfoPanel>
          </div>
        </a-layout-header>
        <a-layout>
          <a-layout-sider v-if="menuList.length !== 0 && menuList[choseMenuIndex].children.length !== 0" id="menu-sider"
            width="250" style="background: #fff;overflow-y: scroll;overflow-x: hidden">
            <a-menu mode="inline" :defaultOpenKeys="choseMenuArray" :selectedKeys="choseMenuArray"
              :style="{ height: '100%', borderRight: 0, }">
              <a-menu-item :key="choseMenuIndex + '-' + menuIndex1"
                v-if="menuItem1.children.length === 0 && menuItem1.is_show" @click="choseMenu(choseMenuIndex, menuIndex1)"
                v-for="(menuItem1, menuIndex1) in menuList[choseMenuIndex].children">
                <a-icon :type="menuItem1.icon" />
                <span>{{ menuItem1.name }}</span>
              </a-menu-item>
              <a-sub-menu v-else-if="menuItem1.is_show" :key="choseMenuIndex + '-' + menuIndex1">
                <span slot="title">
                  <a-icon :type="menuItem1.icon" />
                  {{ menuItem1.name }}
                </span>
                <a-menu-item @click="choseMenu(choseMenuIndex, menuIndex1, menuIndex2)"
                  :key="choseMenuIndex + '-' + menuIndex1 + '-' + menuIndex2" v-if="menuItem2.is_show"
                  v-for="(menuItem2, menuIndex2) in menuList[choseMenuIndex].children[menuIndex1].children">
                  {{ menuItem2.name }}
                </a-menu-item>
              </a-sub-menu>
            </a-menu>
          </a-layout-sider>
          <a-layout>
            <!--<a-breadcrumb style="margin: 16px 0">-->
            <!--  <a-breadcrumb-item>Home</a-breadcrumb-item>-->
            <!--  <a-breadcrumb-item>List</a-breadcrumb-item>-->
            <!--  <a-breadcrumb-item>App</a-breadcrumb-item>-->
            <!--</a-breadcrumb>-->
            <a-layout-content :style="{ padding: '10px', margin: 0, overflowY: 'hidden' }">
              <router-view />
            </a-layout-content>
          </a-layout>
        </a-layout>
      </a-layout>
    </a-config-provider>
    <router-view v-else />
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import ApplicationPanel from "./components/V1/ApplicationPanel";
import { GetBaseApp, GetBaseChannel, GetBaseCountry, GetMenu } from "./api/v1/base_info";
import { SocketBind } from "./api/v1/message_api";
import UserInfoPanel from "./components/V1/UserInfoPanel";
// import moment from 'moment';
// import 'moment/locale/zh-cn';
// moment.locale('zh-cn');
export default {
  name: 'App',
  components: { UserInfoPanel, ApplicationPanel },
  data() {
    return {
      zh_CN,
      menuList: [],
      choseMenuIndex: 0,
      choseMenuArray: ['0-0'],
      timer: '',
      websocket: '',
      defaultAvatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'
    }
  },
  computed: {
    getUser() {
      return this.$store.getters.getUserInfo
    }
  },
  watch: {
    getUser: {
      handler(newName, oldName) {
        if (newName&&newName.id){
          this.init_menu()
          this.init_application()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.init_base()
    try {
      this.connect_socket()
      this.reset_socket()
    }catch (e) {
      console.log("message error")
    }

  },
  methods: {
    init_menu() {
      GetMenu({}).then(resp => {
        if (resp.code === 200) {
          this.menuList = resp.data
          let _path = this.$route.path
          if (_path === "/analysis_report") _path = "/analysis"
          let _is_yep = false

          this.menuList.forEach((item, index) => {
            let _index = index
            if (item.url === _path) {
              this.choseMenuIndex = _index
              this.choseMenuArray = []
              _is_yep = true
            }else{
              item.children.forEach((item1, index1) => {
                let _index1 = index1
                if (item1.url === _path) {
                  this.choseMenuIndex = _index
                  this.choseMenuArray = [_index + '-' + _index1]
                  _is_yep = true
                }else {
                  item1.children.forEach((item2, index2) => {
                    let _index2 = index2
                    if (item2.url === _path) {
                      this.choseMenuIndex = _index
                      this.choseMenuArray = [_index + '-' + _index1, _index + '-' + _index1 + '-' + _index2]
                      _is_yep = true
                    }
                  })
                }
              })
            }
          })
          if (!_is_yep){
            try {
              if (_path!=="/") this.$message.error("抱歉您无权访问此处")
              if (this.menuList[0].url){
                this.$router.push(this.menuList[0].url)
                return
              }
              if (this.menuList[0].children[0].url){
                this.$router.push(this.menuList[0].children[0].url)
                return
              }
              if (this.menuList[0].children[0].children[0].url){
                this.$router.push(this.menuList[0].children[0].children[0].url)
                return
              }
            }catch (e) {
              this.$router.push('/error')
            }
          }
        }
      })
    },
    choseMenu(_index, _index1 = 0, _index2 = 0) {
      this.choseMenuIndex = _index
      this.choseMenuArray = [_index + '-' + _index1, _index + '-' + _index1 + '-' + _index2]
      if (this.menuList[_index].children.length === 0) {
        this.$router.push({ path: this.menuList[_index].url })
        return
      } else if (this.menuList[_index].children[_index1].children.length === 0) {
        this.$router.push({ path: this.menuList[_index].children[_index1].url })
        return
      } else {
        this.$router.push({ path: this.menuList[_index].children[_index1].children[_index2].url })
        return
      }
    },
    init_application() {
      GetBaseApp({}).then(resp => {
        if (resp.code === 200) {
          this.$store.commit('setAppAll', resp.data.all)
          this.$store.commit('setAppList', resp.data.list)
        }
      })
    },
    init_base() {
      GetBaseCountry({}).then(resp => {
        if (resp.code === 200) {
          this.$store.commit('setCountry', resp.data)
        }
      })
      GetBaseChannel({}).then(resp => {
        if (resp.code === 200) {
          this.$store.commit('setSpendChannel', resp.data.spend_channel)
          this.$store.commit('setRevenueChannel', resp.data.revenue_channel)
          this.$store.commit('setAdType', resp.data.ad_type)
        }
      })
    },
    reset_socket() {
      let that = this
      that.timer = setInterval(() => {
        if (this.websocket.readyState === this.websocket.CLOSED) {
          that.connect_socket()
        }

        this.websocket.send("pong");
      }, 30000)
    },
    connect_socket() {
      let websocket;
      let that = this;
      if (typeof WebSocket === "undefined") {
        console.log("您的浏览器不支持WebSocket");
        return;
      } else {
        let url = '';
        if (location.protocol === 'https:') {
           url = 'wss://beta.gamebrain.io:8282';
        } else {
           url = 'ws://beta.gamebrain.io:8282';
        }
        // 打开一个websocket
        this.websocket = websocket = new WebSocket(url);
        // 建立连接
        websocket.onopen = () => {


        };
        // 客户端接收服务端返回的数据
        websocket.onmessage = e => {
          console.log("websocket返回的数据：", e.data);

          let res = JSON.parse(e.data)
          if (res.type && res.type == 'connect') {
            let params = {
              'clientId': res.data,
              'userId': this.$store.getters.getUserInfo.id,
              'system': 'gb',
            }
            SocketBind(params).then(resp => {
              // console.log(resp)
            })
          }

          if (res.type && res.type == 'message') {
            let dataObj = JSON.parse(res.data)
            let placement = 'bottomRight'
            let avatar = ''
            let icon = 'info'

            avatar = dataObj.avatar
            if (dataObj.name && !dataObj.avatar) {
              avatar = dataObj.name
            }
            this.$notification.open({
              message: `站内信`,
              description: dataObj.content,
              placement,
              icon: <a-avatar shape="square" size="large" style="backgroundColor:#1890ff" >{avatar}</a-avatar>,
              onClick: () => {
                console.log('Notification Clicked!');
              },
            });

          }
        };
        // 发生错误时
        websocket.onerror = e => {
          console.log("websocket错误：", e);
        };
        // 关闭连接
        websocket.onclose = e => {
          // clearInterval(that.timer)
          console.log("websocket关闭：", e);
        };
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

#layout {
  width: 100%;
  height: 100%;
}

#layout .logo {
  width: 250px;
  height: 64px;
  text-align: center;
  float: left;
}

#main-content {
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow-x: hidden;
  overflow-y: scroll;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.gb-filter-panel {
  display: flex;
  flex-wrap: wrap;
  /*justify-content: space-between;*/
}

.gb-filter-item {
  height: 50px;
  margin: 10px;
}

.gb-filter-panel:after {
  content: "";
  flex: 1;
}

.gb-filter-label {
  height: 20px;
  line-height: 20px;
}

.gb-filter-content {
  min-width: 200px;
  display: flex;
}

.gb-margin-right {
  margin-right: 10px;
}

.gb-select {
  flex: 1;
  height: 30px;
  position: relative;
}

.gb-date {
  flex: 1;
}

.gb-date .ant-calendar-picker:hover {
  border: none;
  outline: none;
}

.gb-date .ant-calendar-picker-input {
  border: none;
  outline: none;
  border-radius: unset;
  border-bottom: 1px solid #E5E5E5;
}

.gb-select-clear {
  top: 0;
  right: 0;
  height: 30px;
  cursor: pointer;
  line-height: 30px;
  margin-right: 5px;
  position: absolute;
}

.gb-select-list {
  top: 30px;
  z-index: 100;
  width: 100%;
  min-height: 80px;
  max-height: 180px;
  display: none;
  background: #E5E5E5;
  overflow-y: scroll;
  position: absolute;
}

.gb-select-list::-webkit-scrollbar {
  display: none;
}

.gb-select input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid #E5E5E5;
}

.gb-select:hover .gb-select-list {
  display: block;
}

.gb-select-item {
  height: 30px;
  padding: 0 5px;
  cursor: pointer;
  background: #E5E5E5;
  line-height: 30px;
}

.gb-select-item:hover {
  background: #FFFFFF;
}

.gb-button {
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.gb-button.size {
  width: 30px;
}

.gb-button.info {
  background: #EEEEEE;
}

.gb-button.info:hover {
  line-height: 28px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
}

.gb-table-panel {
  flex: 1;
  margin-top: 5px;
  border-top: 1px solid #E5E5E5;
  overflow-y: hidden;
  position: relative;
}

.gb-table-content {
  height: 100%;
  padding-top: 40px;
  overflow-y: scroll;
}

.gb-table-content::-webkit-scrollbar {
  display: none;
}

.gb-table-list {
  height: 40px;
  width: 100%;
  line-height: 40px;
  background: #F5F5F5;
  border-bottom: 1px solid #FFFFFF;
  display: table;
  table-layout: fixed;
}

.gb-table-item {
  display: table-cell;
  text-align: center;
  border-right: 1px solid #FFFFFF;
}

.gb-analysis {
  width: 100%;
  height: 100%;
  padding: 5px;
  display: flex;
  flex-flow: column;
  color: #001529;
  background: #FFFFFF;
}

.norm-panel {
  display: flex;
  margin: 5px 0;
}

.norm-panel-label {
  margin: 5px 0;
  min-width: 60px;
}

.norm-panel-item {
  margin: 5px 5px;
  padding: 0 5px;
  float: left;
  cursor: pointer;
  border-radius: 5px;
}

.norm-panel-item.active {
  color: #1890ff;
}

.text-no {
  color: rgba(0, 0, 0, 0.25);
}
.my-group{
  display: flex;
}
.my-button{
  padding: 5px 10px;
  border: 1px solid #E5E5E5;
}
.my-group-item{
  padding: 5px;
  border-top: 1px solid #E5E5E5;
  border-bottom: 1px solid #E5E5E5;
  border-left: 0.5px solid #E5E5E5;
  border-right: 0.5px solid #E5E5E5;
}
.my-group-item-left{
  border-left: 1px solid #E5E5E5;
  border-radius: 5px 0 0 5px;
}
.my-group-item-right{
  border-right: 1px solid #E5E5E5;
  border-radius: 0 5px 5px 0;
}
.my-year{
  padding: 5px 10px;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  margin-left: 10px;
  position: relative
}
.my-year-list{
  position:absolute;
  background: #FFFFFF;
  width: 100%;
  left: 0;
  margin-top: 6px;
  text-align: center;
  display: none;
  z-index:9999;
}
.my-year:hover>.my-year-list{
  display: block;
}
.my-year-list>div{
  padding: 5px 0
}
.my-year-list>div:hover,.my-year-list>.active,.my-group-item:hover,.my-group-item.active, .my-button:hover{
  background: #1890ff;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue